import '@/App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from '@/pages/HomePage';
import AboutPage from '@/pages/AboutPage';
import MembershipPage from '@/pages/MembershipPage';
import PaymentPage from '@/pages/PaymentPage';
import PaymentSuccessPage from '@/pages/PaymentSuccessPage';
import EventsPage from '@/pages/EventsPage';
import GalleryPage from '@/pages/GalleryPage';
import NewsPage from '@/pages/NewsPage';
import ContactPage from '@/pages/ContactPage';
import { Toaster } from '@/components/ui/sonner';
import { SiteSettingsProvider } from '@/contexts/SiteSettings';

// Admin
import { AdminAuthProvider } from '@/admin/AuthContext';
import AdminLogin from '@/admin/AdminLogin';
import AdminLayout from '@/admin/AdminLayout';
import ProtectedRoute from '@/admin/ProtectedRoute';
import Dashboard from '@/admin/pages/Dashboard';
import SiteSettingsPage from '@/admin/pages/SiteSettings';
import PageContent from '@/admin/pages/PageContent';
import EventsAdmin from '@/admin/pages/Events';
import NewsAdmin from '@/admin/pages/News';
import GalleryAdmin from '@/admin/pages/Gallery';
import HeroSlidesAdmin from '@/admin/pages/HeroSlides';
import MediaAdmin from '@/admin/pages/Media';
import MembersAdmin from '@/admin/pages/Members';
import PaymentsAdmin from '@/admin/pages/Payments';
import MessagesAdmin from '@/admin/pages/Messages';
import UsersAdmin from '@/admin/pages/Users';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <SiteSettingsProvider>
          <AdminAuthProvider>
            <Routes>
              {/* Public site */}
              <Route path="/" element={<HomePage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/membership" element={<MembershipPage />} />
              <Route path="/payment" element={<PaymentPage />} />
              <Route path="/payment/success" element={<PaymentSuccessPage />} />
              <Route path="/events" element={<EventsPage />} />
              <Route path="/gallery" element={<GalleryPage />} />
              <Route path="/news" element={<NewsPage />} />
              <Route path="/contact" element={<ContactPage />} />

              {/* Admin */}
              <Route path="/admin/login" element={<AdminLogin />} />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute>
                    <AdminLayout />
                  </ProtectedRoute>
                }
              >
                <Route index element={<Dashboard />} />
                <Route path="settings" element={<ProtectedRoute adminOnly><SiteSettingsPage /></ProtectedRoute>} />
                <Route path="content" element={<PageContent />} />
                <Route path="hero-slides" element={<HeroSlidesAdmin />} />
                <Route path="events" element={<EventsAdmin />} />
                <Route path="news" element={<NewsAdmin />} />
                <Route path="gallery" element={<GalleryAdmin />} />
                <Route path="media" element={<MediaAdmin />} />
                <Route path="members" element={<MembersAdmin />} />
                <Route path="payments" element={<PaymentsAdmin />} />
                <Route path="messages" element={<MessagesAdmin />} />
                <Route path="users" element={<ProtectedRoute adminOnly><UsersAdmin /></ProtectedRoute>} />
              </Route>
            </Routes>
          </AdminAuthProvider>
        </SiteSettingsProvider>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
